﻿$.fn.dxCtrlSaisieAdresseDetail = function custom_dxCtrlSaisieAdresseDetail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlsaisieadressedetail dx-ctrl");
        this.createInstance(new cdxCtrlSaisieAdresseDetail(this, option));
    }
    return this;
}


window.cdxCtrlSaisieAdresseDetail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            dx.option(name, value);
        }
    }

    if (!option.lstObligatoire) option.lstObligatoire = []

    var _disableOnValueChanged = false
    var dxAd1 = null
    var dxCp = null
    var dxVille = null
    var dxPays = null
    function mConstruit() {
        container.empty();

        dxAd1 = $("<div/>").appendTo(container).dxCtrlSelectBoxAdressePostale({
            bddCtrl: option.bddCtrl,
            labelMode: "floating",
            label: "Adresse" + (option.lstObligatoire.contains("adr") ? " *" : ""),
            value: option.value.adr_ad1,
            isExterne: option.isExterne,
            onFocusIn: option.onFocusIn,
            onValueChanged: function (value) {
                dxAd1.element().css("background-color", "")
                option.value.adr_ad1 = value
                if (option.onValueChanged) option.onValueChanged()
            },
            onSelectItem: function (e) {
                debugger;
                dxAd1.element().css("background-color", "")
                _disableOnValueChanged = true
                dxCp.option("value", e.value.cp)
                option.value.adr_cp = e.value.cp
                dxVille.option("value", e.value.ville)
                option.value.adr_ville = e.value.ville
                dxPays.option("value", e.value.pays)
                option.value.adr_pays = e.value.pays

                _disableOnValueChanged = false
                option.value.adr_ad1 = e.value.adr
                option.value.adr_dpt = e.value.dpt
                option.value.adr_region = e.value.region
                option.value.adr_geo_latitude = e.value.latitude
                option.value.adr_geo_longitude = e.value.longitude
                option.value.adr_code_pays = e.value.code_pays
                if (option.onValueChanged) option.onValueChanged()
            },
            onContentReady: function (e) {
                e.component.element().find(".dx-label").html("Adresse" + (option.lstObligatoire.contains("adr") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlSelectBoxAdressePostale("instance")

        var $Table = $("<table style='width:100%;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        var dxAd2 = $("<div/>").appendTo($Td).dxCtrlTextBox({
            labelMode: "floating",
            label: "Complément d'adresse 1",
            value: option.value.adr_ad2,
            onFocusIn: option.onFocusIn,
            maxLength: 300,
            onValueChanged: function (e) {
                option.value.adr_ad2 = e.value
                if (!_disableOnValueChanged && option.onValueChanged) option.onValueChanged()
            },
            onContentReady: function (e) {
                if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        var dxAd3 = $("<div/>").appendTo($Td).dxCtrlTextBox({
            labelMode: "floating",
            label: "Complément d'adresse 2",
            value: option.value.adr_ad3,
            onFocusIn: option.onFocusIn,
            maxLength: 300,
            onValueChanged: function (e) {
                option.value.adr_ad3 = e.value
                if (!_disableOnValueChanged && option.onValueChanged) option.onValueChanged()
            },
            onContentReady: function (e) {
                if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlTextBox("instance")

        var $Table = $("<table style='width:100%:'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:20%'/>").appendTo($Tr)
        dxCp = $("<div/>").appendTo($Td).dxCtrlTextBox({
            labelMode: "floating",
            label: "Code postal" + (option.lstObligatoire.contains("cp") ? " *" : ""),
            value: option.value.adr_cp,
            onFocusIn: option.onFocusIn,
            maxLength: 300,
            onValueChanged: function (e) {
                dxCp.element().css("background-color", "")
                option.value.adr_cp = e.value
                if (!_disableOnValueChanged && option.onValueChanged) option.onValueChanged()
            },
            onContentReady: function (e) {
                e.component.element().find(".dx-label").html("Code postal" + (option.lstObligatoire.contains("cp") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:40%'/>").appendTo($Tr)
        dxVille = $("<div/>").appendTo($Td).dxCtrlTextBox({
            labelMode: "floating",
            label: "Ville" + (option.lstObligatoire.contains("ville") ? " *" : ""),
            value: option.value.adr_ville,
            onFocusIn: option.onFocusIn,
            maxLength: 300,
            onValueChanged: function (e) {
                dxVille.element().css("background-color", "")
                option.value.adr_ville = e.value
                if (!_disableOnValueChanged && option.onValueChanged) option.onValueChanged()
            },
            onContentReady: function (e) {
                e.component.element().find(".dx-label").html("Ville" + (option.lstObligatoire.contains("ville") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:40%'/>").appendTo($Tr)
        dxPays = $("<div/>").appendTo($Td).dxCtrlSaisiePays({
            bddCtrl: option.bddCtrl,
            label: "Pays" + (option.lstObligatoire.contains("pays") ? " *" : ""),
            value: (option.value.adr_pays ? option.value.adr_pays : ""),
            onFocusIn: option.onFocusIn,
            maxLength: 300,
            onValueChanged: function (e) {
                debugger;
                dxPays.element().css("background-color", "")
                option.value.adr_pays = e.value.name
                option.value.adr_code_pays = e.value.code
                if (!_disableOnValueChanged && option.onValueChanged) option.onValueChanged()
            },
            onContentReady: function (e) {
                e.component.element().find(".dx-label").html("Pays" + (option.lstObligatoire.contains("pays") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlSaisiePays("instance")


    }

    this.mRempliWithInsee = function (itemDataInsee) {
        _disableOnValueChanged = true
        if (!dxAd1.option("value") || dxAd1.option("value").length == 0) {
            dxAd1.option("value", itemDataInsee.adresse_postal.ad1)
            option.value.adr_ad1 = itemDataInsee.adresse_postal.ad1
        }
        if (!dxCp.option("value") || dxCp.option("value").length == 0) {
            dxCp.option("value", itemDataInsee.adresse_postal.cp)
            option.value.adr_cp = itemDataInsee.adresse_postal.cp
        }
        if (!dxVille.option("value") || dxVille.option("value").length == 0) {
            dxVille.option("value", itemDataInsee.adresse_postal.ville)
            option.value.adr_ville = itemDataInsee.adresse_postal.ville
        }
        if (!dxPays.option("value") || dxPays.option("value").length == 0) {
            dxPays.option("value", itemDataInsee.adresse_postal.pays)
            option.value.adr_pays = itemDataInsee.adresse_postal.pays
        }
        option.value.adr_geo_latitude = itemDataInsee.adresse_postal.lat
        option.value.adr_geo_longitude = itemDataInsee.adresse_postal.long
        option.value.adr_code_pays = itemDataInsee.adresse_postal.code_pays
        _disableOnValueChanged = false
        if (!_disableOnValueChanged && option.onValueChanged) option.onValueChanged()
    }

    this.mColorObligatoire = function () {
        var lstCtrlOblig = []
        dxAd1.element().css("background-color", "")
        dxCp.element().css("background-color", "")
        dxVille.element().css("background-color", "")
        dxPays.element().css("background-color", "")
        if (option.lstObligatoire.contains("adr") && (!dxAd1.option("value") || dxAd1.option("value").length == 0)) {
            dxAd1.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxAd1)
        }
        if (option.lstObligatoire.contains("cp") && (!dxCp.option("value") || dxCp.option("value").length == 0)) {
            dxCp.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxCp)
        }
        if (option.lstObligatoire.contains("ville") && (!dxVille.option("value") || dxVille.option("value").length == 0)) {
            dxVille.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxVille)
        }
        if (option.lstObligatoire.contains("pays") && (!dxPays.option("value") || dxPays.option("value").length == 0)) {
            dxPays.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxPays)
        } else if (option.lstObligatoire.contains("code_pays") && (!option.value.adr_code_pays || option.value.adr_code_pays.length == 0)) {
            dxPays.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxPays)
        }
        return lstCtrlOblig
    }

    this.mReload = function () {
        mConstruit()
    }

    this.element = function () { return container; }
    this.focus = function () { dx.focus() }

    mConstruit();
}